import React, { useState } from 'react';
import { usePageContext } from '@wix/bex-core/react';
import { WixPatternsModalsContainer } from '../CairoModalsContainer';
import { CustomFieldModal } from '../CustomFieldModal';
import { observer } from 'mobx-react-lite';
import { CustomFieldsFormState, CustomFieldsWidgetState } from '../../state';
import { CustomFieldsForm } from '../CustomFieldsForm';
import { ExtendedFields } from '@wix/bex-core';
import { ArchiveFieldModal } from '../CustomFieldsPanel/ArchiveFieldModal';
import { EmptyStateContent } from './EmptyStateContent';

export interface CustomFieldsWidgetContentProps {
  state: CustomFieldsWidgetState;
  extendedFields?: ExtendedFields;
  emptyStateOverrides?: {
    title?: string;
    subtitle?: string;
  };
}

const _CustomFieldsWidgetContent = ({
  state,
  extendedFields,
  emptyStateOverrides = {},
}: CustomFieldsWidgetContentProps) => {
  const page = usePageContext();
  const { modalsContainerRef, stackingRootRef } = page;

  const customFields = state.dataExtension.availableUserCustomFields;

  const [formState] = useState(
    () =>
      (state.formState ??= new CustomFieldsFormState({
        translate: state.container.translate,
        schema: customFields,
        extendedFields: extendedFields?.namespaces?._user_fields,
      })),
  );

  return (
    <>
      {customFields.length > 0 ? (
        <CustomFieldsForm dataHook="custom-fields-form" state={formState} />
      ) : (
        <EmptyStateContent
          state={state}
          emptyStateOverrides={emptyStateOverrides}
        />
      )}
      <WixPatternsModalsContainer
        rootRef={stackingRootRef}
        anchorRef={modalsContainerRef}
        state={state.panels}
      />
      <CustomFieldModal state={state.dataExtension} />
      <ArchiveFieldModal state={state.dataExtension} />
    </>
  );
};

export const CustomFieldsWidgetContent = observer(_CustomFieldsWidgetContent);
